import { IconButton, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Controller } from "react-hook-form";

import { CloseWhite } from "../../../icons/index.js";

const useStyles = makeStyles({
  input: {
    padding: "0px",
  },
  textFieldContainer: {
    display: "flex",
    color: "#fff",
    fontSize: "16px",
    alignItems: "flex-start",
    flexDirection: "column",
    position: "relative",

    "& .MuiFormControl-root": {
      height: "56px",
      margin: "0 !important",
      color: "#757575",
      fontSize: "16px",
      fontWeight: "400",
      lineHeight: "24px",
      "@media (max-width:699px)": {
        width: "100%",
      },
    },
    "& .MuiSvgIcon-root": {
      fontSize: "16px",
      margin: "0px 22px 16px 0px",
    },
    "& .MuiInput-root": {
      backgroundColor: "#161616",
      marginTop: "0px",
      paddingTop: "16px",
      borderTopLeftRadius: "4px",
      borderTopRightRadius: "4px",
      borderBottom: "1px solid #757575",

      "&.Mui-disabled": {
        backgroundColor: "#0b0b0b",
      },
      "&::before": {
        border: "none !important",
      },
      "&::after": {
        border: "none",
      },
    },
    "& .MuiInputBase-input": {
      color: "#fff",
      padding: "8px 16px",
      backgroundColor: "#161616",
      "&.Mui-disabled": {
        backgroundColor: "#0b0b0b",
        color: "#757575",
        "-webkit-text-fill-color": "#757575",
      },
    },
  },
  textField: {
    flex: "1",
    backgroundColor: "transparent !important",

    "& label": {
      color: "#757575",
      zIndex: 99,
      padding: "0 16px",
    },
    "& label.Mui-disabled": {
      color: "#757575",
    },
    "& label.Mui-focused": {
      color: `#757575`,
      padding: "8px 16px",
    },
    "& label.MuiFormLabel-filled": {
      padding: "8px 16px",
    },
    "& .MuiFormHelperText-root": {
      position: "absolute",
      bottom: "-20px",
      left: "16px",
      fontSize: "12px",
      lineHeight: "16px",
      fontWeight: "400",
    },
    "& .Mui-error": {
      color: "#FF0000 !important",
    },
    "& .MuiInputBase-input": {
      fontSize: "14px",
      height: "40px",
      boxSizing: "border-box",
    },
  },
});

export default function FormTextFieldDark(props) {
  const {
    control,
    name,
    label,
    disabled = false,
    placeholder = "",
    size,
    variant = "outlined",
    fullWidth = true,
    autoFocus = false,
    style = {},
    onBlur,
    onChange,
    type = "",
    margin = "normal",
    helperText,
    hidden,
    hideErrMessage = false,
    ...rest
  } = props;

  const classes = useStyles();

  const handleClearText = (field) => {
    if (onChange) {
      onChange("");
    }
    field.onChange("");
  };

  return (
    <div className={classes.textFieldContainer} data-testid={`${name}-text-field`}>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) => {
          const { error, invalid, isDirty, isTouched } = fieldState;
          return (
            <>
              <TextField
                name={field.name}
                ref={field.ref}
                disabled={disabled}
                classes={{ root: classes.textField }}
                className={classes.input}
                fullWidth={fullWidth}
                autoFocus={autoFocus}
                type={type}
                label={label}
                margin={margin}
                size={size}
                placeholder={placeholder}
                variant={variant}
                style={{
                  display: hidden && !field.value && `none`,
                  ...style,
                }}
                error={!hideErrMessage && (isDirty || isTouched) && invalid}
                helperText={(!hideErrMessage && (isDirty || isTouched) && invalid && error?.message) || helperText}
                value={field.value}
                onChange={(e) => {
                  if (onChange) {
                    onChange(e);
                  }
                  field.onChange(e);
                }}
                onBlur={(e) => {
                  if (onBlur) {
                    onBlur(e);
                  }
                  field.onBlur(e);
                }}
                InputProps={{
                  endAdornment: (
                    <IconButton
                      onClick={() => handleClearText(field)}
                      sx={{ visibility: field.value ? "visible" : "hidden" }}
                    >
                      <CloseWhite htmlColor="#757575" />
                    </IconButton>
                  ),
                }}
                {...rest}
              />
            </>
          );
        }}
      />
    </div>
  );
}
